import { createComponent } from 'react-fela'

const baseProps = [
  'data-automation',
  'data-component',
  'data-cm-metadata',
  'data-testid',
  'data-content-id',
  'itemScope',
  'itemProp',
  'itemType',
  'alt',
  'displayName',
  'href',
  'key',
  'src',
  'target',
  'onClick',
  'onMouseEnter',
  'onMouseLeave',
  'onMouseOut',
  'hidden',
  'disabled',
  'dir'
]

export default (displayName, rule, type = 'div', passThroughProps = []) => {
  const enhancedRule = customRule(rule)
  Object.defineProperty(enhancedRule, 'name', { value: displayName, configurable: true })
  const Component = createComponent(enhancedRule, type, [...baseProps, ...passThroughProps])
  return Component
}

export const customRule = (rule) => (props) => {
  const result = rule(props)

  if (result?.typography && props?.theme?.typestack) {
    const { typography, ...otherStyles } = result
    const typographyStyles = props.theme.typestack[typography]

    if (typographyStyles) {
      return {
        ...typographyStyles,
        ...otherStyles
      }
    }
  }

  return result
}
